import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../store/hooks"
import {
  checkAuth,
  logout,
  selectUser,
  selectIsAuthenticated,
  selectIsLoading,
  selectMaintenanceMode,
} from "../store/sessionSlice"

export function useAuth() {
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectUser)
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const isLoading = useAppSelector(selectIsLoading)
  const maintenanceMode = useAppSelector(selectMaintenanceMode)

  const handleLogout = () => {
    dispatch(logout())
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    maintenanceMode,
    logout: handleLogout,
    refreshAuth: () => dispatch(checkAuth()),
  }
}

export function useRequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Redirect to login, preserving the intended destination
      navigate("/login", {
        state: { from: location.pathname },
        replace: true,
      })
    }
  }, [isAuthenticated, isLoading, navigate, location])

  return { isAuthenticated, isLoading }
}
